import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "bg-gray-100 flex flex-col min-h-screen" }
const _hoisted_2 = { class: "bg-gray-800 h-16" }
const _hoisted_3 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_4 = { class: "flex items-center justify-between h-16" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-8",
    src: "/images/logo.png",
    alt: "ThePornDB"
  })
], -1)
const _hoisted_7 = { class: "hidden md:block" }
const _hoisted_8 = { class: "ml-10 flex items-center space-x-2" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Donate ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Discord ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Plex ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Stash ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" JellyFin ")
const _hoisted_14 = { class: "hidden md:block" }
const _hoisted_15 = { class: "ml-4 flex items-center md:ml-6" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_17 = {
  key: 1,
  class: "ml-3 relative"
}
const _hoisted_18 = {
  id: "user-menu-button",
  type: "button",
  class: "max-w-xs bg-gray-100 ring-1 ring-gray-100 transform hover:scale-110 rounded-full flex items-center text-sm text-white",
  "aria-expanded": "false",
  "aria-haspopup": "true"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open user menu", -1)
const _hoisted_20 = ["src"]
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Your Profile")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Log Out")
const _hoisted_23 = { class: "-mr-2 flex md:hidden" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open main menu", -1)
const _hoisted_25 = {
  class: "block h-6 w-6",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "aria-hidden": "true"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M4 6h16M4 12h16M4 18h16"
}, null, -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  class: "block h-6 w-6",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "aria-hidden": "true"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M6 18L18 6M6 6l12 12"
}, null, -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  id: "mobile-menu",
  class: "md:hidden"
}
const _hoisted_32 = { class: "px-2 pt-2 pb-3 space-y-1 sm:px-3" }
const _hoisted_33 = { class: "flex items-center px-5" }
const _hoisted_34 = { class: "flex-shrink-0" }
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "ml-3" }
const _hoisted_37 = { class: "text-base font-medium text-white" }
const _hoisted_38 = { class: "mt-3 px-2 space-y-1" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Your Profile ")
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" Settings ")
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Sign Out ")
const _hoisted_42 = /*#__PURE__*/_createElementVNode("header", { class: "bg-white shadow-sm" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-lg leading-6 font-semibold text-gray-900" })
  ])
], -1)
const _hoisted_43 = { class: "flex-grow py-6" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("footer", { class: "bg-gray-800 h-14" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_consent_overlay = _resolveComponent("consent-overlay")!
  const _component_b_nav_link = _resolveComponent("b-nav-link")!
  const _component_b_icon = _resolveComponent("b-icon")!
  const _component_b_nav_menu = _resolveComponent("b-nav-menu")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createVNode(_component_consent_overlay, null, null, 512), [
      [_vShow, _ctx.showConsentModal]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("nav", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routes, (route) => {
                    return (_openBlock(), _createBlock(_component_b_nav_link, {
                      key: `desktop-uri-${route.url}`,
                      label: route.text,
                      to: route.url
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(route.text), 1)
                      ]),
                      _: 2
                    }, 1032, ["label", "to"]))
                  }), 128)),
                  _createVNode(_component_b_nav_link, { href: "https://www.patreon.com/metadataapi" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_icon, {
                        icon: "jam:patreon-square",
                        height: "22",
                        class: "mr-1"
                      }),
                      _hoisted_9
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_b_nav_link, { href: "https://discord.gg/XpSGpaB" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_icon, {
                        icon: "bx:bxl-discord",
                        height: "22",
                        inline: "",
                        class: "mr-1 inline"
                      }),
                      _hoisted_10
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_b_nav_menu, { label: "Tools/Plugins" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_nav_link, { href: "https://github.com/ThePornDatabase/ThePornDB.bundle" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_icon, {
                            icon: "simple-icons:plex",
                            class: "mr-2"
                          }),
                          _hoisted_11
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_b_nav_link, { href: "https://github.com/ThePornDatabase/stash_theporndb_scraper" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_icon, {
                            icon: "fa-solid:box-open",
                            class: "mr-2"
                          }),
                          _hoisted_12
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_b_nav_link, { href: "https://github.com/ThePornDatabase/Jellyfin.Plugin.ThePornDB" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_icon, {
                            icon: "simple-icons:jellyfin",
                            class: "mr-2"
                          }),
                          _hoisted_13
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_b_nav_link, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.settingStore.toggleSfwMode()))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.settingStore.sfwMode ? 'font-bold text-white underline' : '')
                    }, "SFW", 2),
                    _hoisted_16,
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.settingStore.sfwMode ? '' : 'font-bold text-white underline')
                    }, "NSFW", 2)
                  ]),
                  _: 1
                }),
                (!_ctx.loggedIn)
                  ? (_openBlock(), _createBlock(_component_b_nav_link, {
                      key: 0,
                      label: "Login",
                      onClick: _ctx.login
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.loggedIn)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createVNode(_component_b_nav_menu, null, {
                        button: _withCtx(() => [
                          _createElementVNode("button", _hoisted_18, [
                            _hoisted_19,
                            _createElementVNode("img", {
                              class: "h-8 w-8 rounded-full",
                              src: _ctx.avatar,
                              alt: ""
                            }, null, 8, _hoisted_20)
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_b_nav_link, { to: "/profile" }, {
                            default: _withCtx(() => [
                              _hoisted_21
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_b_nav_link, {
                            onClick: _withModifiers(_ctx.logout, ["prevent"])
                          }, {
                            default: _withCtx(() => [
                              _hoisted_22
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("button", {
                type: "button",
                class: "bg-gray-800 inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white",
                "aria-controls": "mobile-menu",
                "aria-expanded": "false",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMobileMenu = !_ctx.showMobileMenu))
              }, [
                _hoisted_24,
                _withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_25, _hoisted_27, 512)), [
                  [_vShow, !_ctx.showMobileMenu]
                ]),
                _withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_28, _hoisted_30, 512)), [
                  [_vShow, _ctx.showMobileMenu]
                ])
              ])
            ])
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routes, (route) => {
              return (_openBlock(), _createBlock(_component_b_nav_link, {
                key: `desktop-uri-${route.url}`,
                label: route.text,
                mobile: "",
                to: route.url
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(route.text), 1)
                ]),
                _: 2
              }, 1032, ["label", "to"]))
            }), 128))
          ]),
          (_ctx.loggedIn)
            ? (_openBlock(), _createBlock(_component_b_nav_menu, {
                key: 0,
                mobile: "",
                class: "pt-4 pb-3 border-t border-gray-700"
              }, {
                button: _withCtx(() => [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("img", {
                        class: "h-10 w-10 rounded-full",
                        src: _ctx.avatar,
                        alt: ""
                      }, null, 8, _hoisted_35)
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.user.username), 1)
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_component_b_nav_link, { to: "/user/profile" }, {
                      default: _withCtx(() => [
                        _hoisted_39
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_b_nav_link, null, {
                      default: _withCtx(() => [
                        _hoisted_40
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_b_nav_link, { onClick: _ctx.logout }, {
                      default: _withCtx(() => [
                        _hoisted_41
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, _ctx.showMobileMenu]
        ])
      ]),
      _hoisted_42,
      _createElementVNode("main", _hoisted_43, [
        _renderSlot(_ctx.$slots, "default"),
        _createVNode(_component_router_view)
      ]),
      _hoisted_44
    ], 512), [
      [_vShow, !_ctx.showConsentModal]
    ])
  ]))
}